import { forwardRef, memo } from "react";

export const EnvelopeIcon = memo(
  forwardRef(function EnvelopeIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 21 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1663 10.8189C9.53494 10.8189 8.90552 10.6103 8.37896 10.1932L4.14663 6.78095C3.84183 6.5356 3.79465 6.08924 4.03905 5.78538C4.28535 5.48247 4.73076 5.43434 5.03462 5.67875L9.26317 9.08726C9.79445 9.50813 10.5428 9.50813 11.0778 9.08348L15.2639 5.68064C15.5678 5.43245 16.0132 5.47964 16.2604 5.7835C16.5067 6.08641 16.4605 6.53182 16.1576 6.77906L11.9639 10.1876C11.4336 10.6084 10.7994 10.8189 10.1663 10.8189"
          fill={color}
        />
        <mask
          id="mask0_15054_24177"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="21"
          height="19"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H20.2886V18.4014H0V0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_15054_24177)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.51004 16.9859H14.7768C14.7787 16.984 14.7862 16.9859 14.7919 16.9859C15.8686 16.9859 16.8236 16.6009 17.5559 15.8696C18.4061 15.0231 18.8732 13.8067 18.8732 12.445V5.96394C18.8732 3.3283 17.1501 1.41549 14.7768 1.41549H5.51193C3.13862 1.41549 1.41549 3.3283 1.41549 5.96394V12.445C1.41549 13.8067 1.88355 15.0231 2.73285 15.8696C3.46513 16.6009 4.42106 16.9859 5.49683 16.9859H5.51004ZM5.494 18.4014C4.03793 18.4014 2.73756 17.873 1.73351 16.8727C0.615268 15.7573 0 14.1851 0 12.445V5.96394C0 2.56393 2.36954 0 5.51193 0H14.7768C17.9192 0 20.2887 2.56393 20.2887 5.96394V12.445C20.2887 14.1851 19.6735 15.7573 18.5552 16.8727C17.5521 17.872 16.2508 18.4014 14.7919 18.4014H14.7768H5.51193H5.494Z"
            fill={color}
          />
        </g>
      </svg>
    );
  }),
);

EnvelopeIcon.displayName = "EnvelopeIcon";